import React, { useState, useEffect, useMemo } from 'react';
import { useNavigate } from 'react-router-dom';
import { toast } from 'react-toastify';
import { getExecucoes, deleteExecucao } from '../services/api';
import ConfirmDialog from '../../../common/ConfirmDialog';

// Ícones
const PlayCircle = ({ className }) => (
  <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24"
    fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round"
    strokeLinejoin="round" className={className}>
    <circle cx="12" cy="12" r="10" />
    <polygon points="10 8 16 12 10 16 10 8" />
  </svg>
);

const AlertTriangle = ({ className }) => (
  <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24"
    fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round"
    strokeLinejoin="round" className={className}>
    <path d="m21.73 18-8-14a2 2 0 0 0-3.46 0l-8 14A2 2 0 0 0 4 21h16a2 2 0 0 0 1.73-3Z" />
    <line x1="12" x2="12" y1="9" y2="13" />
    <line x1="12" x2="12.01" y1="17" y2="17" />
  </svg>
);

const Eye = ({ className }) => (
  <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" className={className}>
    <path d="M1 12s4-8 11-8 11 8 11 8-4 8-11 8-11-8-11-8z" />
    <circle cx="12" cy="12" r="3" />
  </svg>
);

const Trash2 = ({ className }) => (
  <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" className={className}>
    <path d="M3 6h18" />
    <path d="M19 6v14a2 2 0 0 1-2 2H7a2 2 0 0 1-2-2V6" />
    <path d="M8 6V4a2 2 0 0 1 2-2h4a2 2 0 0 1 2 2v2" />
    <line x1="10" y1="11" x2="10" y2="17" />
    <line x1="14" y1="11" x2="14" y2="17" />
  </svg>
);

const Calendar = ({ className }) => (
    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" className={className}><rect x="3" y="4" width="18" height="18" rx="2" ry="2"/><line x1="16" y1="2" x2="16" y2="6"/><line x1="8" y1="2" x2="8" y2="6"/><line x1="3" y1="10" x2="21" y2="10"/></svg>
);

const ChevronsUpDown = ({ className }) => (
    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" className={className}><path d="m7 15 5 5 5-5"/><path d="m7 9 5-5 5 5"/></svg>
);

const SortUp = ({ className }) => (
    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" className={className}><path d="m3 16 4 4 4-4"/><path d="M7 20V4"/><path d="M11 4h10"/><path d="M11 8h7"/><path d="M11 12h4"/></svg>
);

const SortDown = ({ className }) => (
    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" className={className}><path d="m3 8 4-4 4 4"/><path d="M7 4v16"/><path d="M11 12h10"/><path d="M11 16h7"/><path d="M11 20h4"/></svg>
);

const Pagination = ({ currentPage, totalPages, onPageChange }) => {
  if (totalPages <= 1) return null;
  const pages = Array.from({ length: totalPages }, (_, i) => i + 1);
  return (
    <div className="mt-4 flex justify-center items-center gap-2">
      <button
        onClick={() => onPageChange(currentPage - 1)}
        disabled={currentPage === 1}
        className={`px-3 py-1 rounded ${currentPage === 1 ? 'bg-gray-200 text-gray-400 cursor-not-allowed' : 'bg-white border border-gray-300 text-gray-700 hover:bg-gray-50'}`}
      >
        Anterior
      </button>
      {pages.map(p => (
        <button
          key={p}
          onClick={() => onPageChange(p)}
          className={`px-3 py-1 rounded ${p === currentPage ? 'bg-purple-600 text-white' : 'bg-white border border-gray-300 text-gray-700 hover:bg-gray-50'}`}
        >
          {p}
        </button>
      ))}
      <button
        onClick={() => onPageChange(currentPage + 1)}
        disabled={currentPage === totalPages}
        className={`px-3 py-1 rounded ${currentPage === totalPages ? 'bg-gray-200 text-gray-400 cursor-not-allowed' : 'bg-white border border-gray-300 text-gray-700 hover:bg-gray-50'}`}
      >
        Próxima
      </button>
    </div>
  );
};


const ExecucoesListPage = () => {
  const [execucoes, setExecucoes] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [deleteId, setDeleteId] = useState(null);
  const [unidadeFiltro, setUnidadeFiltro] = useState('');
  const [startDate, setStartDate] = useState('');
  const [endDate, setEndDate] = useState('');
  const navigate = useNavigate();

  const [sortConfig, setSortConfig] = useState({ key: 'iniciado_em', direction: 'descending' });

  const ITEMS_PER_PAGE = 5;
  const [emAndamentoPage, setEmAndamentoPage] = useState(1);
  const [concluidasPage, setConcluidasPage] = useState(1);

  const unidades = Array.from(
    new Set(execucoes.map(e => e.unidades?.nome).filter(Boolean))
  ).sort();

  const handleDelete = async () => {
    try {
      await deleteExecucao(deleteId);
      setExecucoes(execucoes.filter(e => e.execucao_id !== deleteId));
      setDeleteId(null);
      toast.success('Execução excluída com sucesso!');
    } catch (err) {
      console.error(err);
      toast.error(`Erro ao excluir execução: ${err.message}`);
    }
  };

  useEffect(() => {
    const loadExecucoes = async () => {
      try {
        setLoading(true);
        const data = await getExecucoes();
        setExecucoes(data);
      } catch (err) {
        setError(err.message);
      } finally {
        setLoading(false);
      }
    };
    loadExecucoes();
  }, []);

  const sortedAndFilteredExecucoes = useMemo(() => {
    let filtered = [...execucoes].filter(e => {
      if (unidadeFiltro && e.unidades?.nome !== unidadeFiltro) {
        return false;
      }
      const started = new Date(e.iniciado_em);
      if (startDate) {
        const [year, month, day] = startDate.split('-').map(Number);
        const start = new Date(Date.UTC(year, month - 1, day, 0, 0, 0));
        if (started < start) return false;
      }
      if (endDate) {
        const [year, month, day] = endDate.split('-').map(Number);
        const end = new Date(Date.UTC(year, month - 1, day, 23, 59, 59, 999));
        if (started > end) return false;
      }
      return true;
    });

    if (sortConfig.key) {
      filtered.sort((a, b) => {
        const getNestedValue = (obj, path) => path.split('.').reduce((o, i) => (o ? o[i] : null), obj);
        
        const aValue = getNestedValue(a, sortConfig.key);
        const bValue = getNestedValue(b, sortConfig.key);

        if (aValue < bValue) {
          return sortConfig.direction === 'ascending' ? -1 : 1;
        }
        if (aValue > bValue) {
          return sortConfig.direction === 'ascending' ? 1 : -1;
        }
        return 0;
      });
    }

    return filtered;
  }, [execucoes, unidadeFiltro, startDate, endDate, sortConfig]);
  
  const requestSort = (key) => {
    let direction = 'ascending';
    if (sortConfig.key === key && sortConfig.direction === 'ascending') {
      direction = 'descending';
    }
    setSortConfig({ key, direction });
  };

  const getSortIcon = (key) => {
    if (sortConfig.key !== key) {
      return <ChevronsUpDown className="h-4 w-4 text-gray-400 ml-1 inline-block" />;
    }
    if (sortConfig.direction === 'ascending') {
      return <SortUp className="h-4 w-4 text-purple-600 ml-1 inline-block" />;
    }
    return <SortDown className="h-4 w-4 text-purple-600 ml-1 inline-block" />;
  };

  const handleClearFilters = () => {
    setUnidadeFiltro('');
    setStartDate('');
    setEndDate('');
  };

  const emAndamento = sortedAndFilteredExecucoes.filter(e => e.status === 'EM_ANDAMENTO');
  const concluidas = sortedAndFilteredExecucoes.filter(e => e.status === 'CONCLUIDO');

  const totalEmAndamentoPages = Math.ceil(emAndamento.length / ITEMS_PER_PAGE) || 1;
  const totalConcluidasPages = Math.ceil(concluidas.length / ITEMS_PER_PAGE) || 1;

  const emAndamentoToShow = useMemo(() => {
    const start = (emAndamentoPage - 1) * ITEMS_PER_PAGE;
    return emAndamento.slice(start, start + ITEMS_PER_PAGE);
  }, [emAndamento, emAndamentoPage]);

  const concluidasToShow = useMemo(() => {
    const start = (concluidasPage - 1) * ITEMS_PER_PAGE;
    return concluidas.slice(start, start + ITEMS_PER_PAGE);
  }, [concluidas, concluidasPage]);

  useEffect(() => {
    setEmAndamentoPage(1);
    setConcluidasPage(1);
  }, [unidadeFiltro, startDate, endDate, sortConfig]);

  if (loading) return <div className="p-6 text-center">A carregar execuções...</div>;
  if (error) return (
    <div className="p-6 text-center">
      <AlertTriangle className="h-12 w-12 text-red-500 mx-auto mb-4" />
      <h2 className="text-xl font-bold text-gray-800">Erro ao Carregar</h2>
      <p className="text-gray-600 mt-2">{error}</p>
    </div>
  );

  return (
    <div className="p-6 bg-gray-50 min-h-screen">
      <h1 className="text-3xl font-bold text-gray-800 mb-6">Execuções de Checklist</h1>

      <div className="bg-white p-4 rounded-xl shadow-md mb-8 border border-gray-100">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-4 items-end">
          <div>
            <label className="block text-sm font-medium text-gray-600 mb-1">Unidade</label>
            <select
              className="w-full border border-gray-300 rounded-lg px-3 py-2 text-sm text-gray-800 focus:ring-2 focus:ring-purple-500 bg-white"
              value={unidadeFiltro}
              onChange={e => setUnidadeFiltro(e.target.value)}
            >
              <option value="">Todas as unidades</option>
              {unidades.map(u => (
                <option key={u} value={u}>{u}</option>
              ))}
            </select>
          </div>
          <div>
            <label className="block text-sm font-medium text-gray-600 mb-1">Data de Início</label>
            <div className="relative">
              <Calendar className="absolute left-3 top-1/2 -translate-y-1/2 h-5 w-5 text-gray-400 pointer-events-none" />
              <input
                type="date"
                className="w-full border border-gray-300 rounded-lg pl-10 pr-3 py-2 text-sm text-gray-800 focus:ring-2 focus:ring-purple-500"
                value={startDate}
                onChange={e => setStartDate(e.target.value)}
              />
            </div>
          </div>
          <div>
            <label className="block text-sm font-medium text-gray-600 mb-1">Data de Fim</label>
             <div className="relative">
              <Calendar className="absolute left-3 top-1/2 -translate-y-1/2 h-5 w-5 text-gray-400 pointer-events-none" />
              <input
                type="date"
                className="w-full border border-gray-300 rounded-lg pl-10 pr-3 py-2 text-sm text-gray-800 focus:ring-2 focus:ring-purple-500"
                value={endDate}
                onChange={e => setEndDate(e.target.value)}
              />
            </div>
          </div>
          <div>
            <button 
              onClick={handleClearFilters}
              className="w-full bg-gray-200 text-gray-700 font-semibold py-2 px-4 rounded-lg hover:bg-gray-300 transition-colors"
            >
              Limpar Filtros
            </button>
          </div>
        </div>
      </div>

      <div className="mb-10">
        <h2 className="text-xl font-semibold text-gray-700 mb-4">Em Andamento</h2>

        {/* MOBILE (cards) */}
        <div className="md:hidden space-y-3">
          {emAndamento.length === 0 && (
            <p className="text-gray-500">Nenhum checklist em andamento.</p>
          )}
          {emAndamentoToShow.map((exec) => (
            <div
              key={exec.execucao_id}
              className="bg-white rounded-xl shadow-sm border border-gray-100 p-4"
            >
              <div className="flex items-start justify-between gap-3">
                <div className="min-w-0">
                  <p className="text-sm text-gray-500">Checklist</p>
                  <p className="font-semibold text-gray-900 truncate">
                    {exec.checklist_modelos?.titulo || 'Modelo não encontrado'}
                  </p>

                  <div className="mt-2 grid grid-cols-2 gap-2">
                    <div className="min-w-0">
                      <p className="text-xs text-gray-500">Unidade</p>
                      <p className="text-sm text-gray-800 truncate">
                        {exec.unidades?.nome || '—'}
                      </p>
                    </div>
                    <div>
                      <p className="text-xs text-gray-500">Iniciado em</p>
                      <p className="text-sm text-gray-800">
                        {new Date(exec.iniciado_em).toLocaleString()}
                      </p>
                    </div>
                  </div>
                </div>

                <span className="px-2 py-1 text-[11px] leading-4 font-semibold rounded-full bg-yellow-100 text-yellow-800 shrink-0">
                  Em andamento
                </span>
              </div>

              <div className="mt-4 flex gap-2">
                <button
                  onClick={() => navigate(`/checklist/execucoes/${exec.execucao_id}`)}
                  className="flex-1 flex items-center justify-center gap-1.5 px-3 py-2 rounded-md bg-purple-600 text-white text-sm font-semibold hover:bg-purple-700 transition"
                >
                  <PlayCircle className="h-4 w-4" />
                  Continuar
                </button>
                <button
                  onClick={() => setDeleteId(exec.execucao_id)}
                  className="px-3 py-2 rounded-md bg-white text-red-600 border border-red-200 text-sm font-semibold hover:bg-red-50 transition"
                >
                  Excluir
                </button>
              </div>
            </div>
          ))}
        </div>

        {/* DESKTOP (tabela atual) */}
        {emAndamento.length > 0 && (
          <div className="hidden md:block bg-white rounded-lg shadow-sm border border-gray-100 overflow-x-auto">
            <table className="min-w-full text-sm">
              <thead className="bg-gray-50">
                <tr>
                  <th
                    className="px-6 py-3 text-left font-semibold text-gray-500 uppercase tracking-wider cursor-pointer hover:bg-gray-100"
                    onClick={() => requestSort('checklist_modelos.titulo')}
                  >
                    Checklist {getSortIcon('checklist_modelos.titulo')}
                  </th>
                  <th
                    className="px-6 py-3 text-left font-semibold text-gray-500 uppercase tracking-wider cursor-pointer hover:bg-gray-100"
                    onClick={() => requestSort('unidades.nome')}
                  >
                    Unidade {getSortIcon('unidades.nome')}
                  </th>
                  <th
                    className="px-6 py-3 text-left font-semibold text-gray-500 uppercase tracking-wider cursor-pointer hover:bg-gray-100"
                    onClick={() => requestSort('iniciado_em')}
                  >
                    Iniciado em {getSortIcon('iniciado_em')}
                  </th>
                  <th className="px-6 py-3 text-left font-semibold text-gray-500 uppercase tracking-wider">
                    Status
                  </th>
                  <th className="px-6 py-3 text-center font-semibold text-gray-500 uppercase tracking-wider">
                    Ações
                  </th>
                </tr>
              </thead>
              <tbody className="divide-y divide-gray-100">
                {emAndamentoToShow.map((exec) => (
                  <tr key={exec.execucao_id} className="hover:bg-purple-50 transition">
                    <td className="px-6 py-4 font-medium max-w-[250px] truncate">
                      {exec.checklist_modelos?.titulo || 'Modelo não encontrado'}
                    </td>
                    <td className="px-6 py-4 text-gray-700">
                      {exec.unidades?.nome || 'Unidade não encontrada'}
                    </td>
                    <td className="px-6 py-4 text-gray-700">
                      {new Date(exec.iniciado_em).toLocaleString()}
                    </td>
                    <td className="px-6 py-4">
                      <span className="px-2 inline-flex text-xs leading-5 font-semibold rounded-full bg-yellow-100 text-yellow-800">
                        Em andamento
                      </span>
                    </td>
                    <td className="px-6 py-4 text-center">
                      <div className="flex justify-center gap-2">
                        <button
                          onClick={() => navigate(`/checklist/execucoes/${exec.execucao_id}`)}
                          className="flex items-center px-3 py-1.5 rounded-md bg-purple-600 text-white text-xs font-semibold hover:bg-purple-700 transition"
                        >
                          <PlayCircle className="h-4 w-4 mr-1" />
                          Continuar
                        </button>
                        <button
                          onClick={() => setDeleteId(exec.execucao_id)}
                          className="flex items-center px-3 py-1.5 rounded-md bg-white text-red-600 border border-red-200 text-xs font-semibold hover:bg-red-50 transition"
                        >
                          Excluir
                        </button>
                      </div>
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        )}
        <Pagination currentPage={emAndamentoPage} totalPages={totalEmAndamentoPages} onPageChange={setEmAndamentoPage} />
      </div>

      <div>
        <h2 className="text-xl font-semibold text-gray-700 mb-4">
          Histórico (Concluídos)
        </h2>

        {/* MOBILE (cards) */}
        <div className="md:hidden space-y-3">
          {concluidas.length === 0 && (
            <p className="text-gray-500">Nenhum checklist concluído ainda.</p>
          )}
          {concluidasToShow.map((exec) => (
            <div
              key={exec.execucao_id}
              className="bg-white rounded-xl shadow-sm border border-gray-100 p-4"
            >
              <div className="flex items-start justify-between gap-3">
                <div className="min-w-0">
                  <p className="text-sm text-gray-500">Checklist</p>
                  <p className="font-semibold text-gray-900 truncate">
                    {exec.checklist_modelos?.titulo}
                  </p>

                  <div className="mt-2 grid grid-cols-2 gap-2">
                    <div className="min-w-0">
                      <p className="text-xs text-gray-500">Unidade</p>
                      <p className="text-sm text-gray-800 truncate">
                        {exec.unidades?.nome}
                      </p>
                    </div>
                    <div>
                      <p className="text-xs text-gray-500">Concluído em</p>
                      <p className="text-sm text-gray-800">
                        {new Date(exec.concluido_em).toLocaleString()}
                      </p>
                    </div>
                  </div>
                </div>

                <span className="px-2 py-1 text-[11px] leading-4 font-semibold rounded-full bg-green-100 text-green-800 shrink-0">
                  Concluído
                </span>
              </div>

              <div className="mt-4 flex gap-2">
                <button
                  onClick={() => navigate(`/checklist/execucoes/${exec.execucao_id}/detalhes`)}
                  className="flex-1 bg-purple-600 hover:bg-purple-700 text-white px-3 py-2 rounded-md transition-colors flex items-center justify-center gap-1.5 text-sm font-semibold"
                  title="Visualizar"
                >
                  <Eye className="h-4 w-4" />
                  Visualizar
                </button>
                <button
                  onClick={() => setDeleteId(exec.execucao_id)}
                  className="px-3 py-2 rounded-md bg-white text-red-600 border border-red-200 text-sm font-semibold hover:bg-red-50 transition"
                  title="Excluir"
                >
                  <Trash2 className="h-4 w-4" />
                </button>
              </div>
            </div>
          ))}

        </div>

        {/* DESKTOP (tabela) */}
        {concluidas.length > 0 && (
          <div className="hidden md:block bg-white rounded-lg shadow-sm border border-gray-100 overflow-x-auto">
            <table className="min-w-full text-sm">
              <thead className="bg-gray-50">
                <tr>
                  <th
                    className="px-6 py-3 text-left font-semibold text-gray-500 uppercase tracking-wider cursor-pointer hover:bg-gray-100"
                    onClick={() => requestSort('checklist_modelos.titulo')}
                  >
                    Checklist {getSortIcon('checklist_modelos.titulo')}
                  </th>
                  <th
                    className="px-6 py-3 text-left font-semibold text-gray-500 uppercase tracking-wider cursor-pointer hover:bg-gray-100"
                    onClick={() => requestSort('unidades.nome')}
                  >
                    Unidade {getSortIcon('unidades.nome')}
                  </th>
                  <th
                    className="px-6 py-3 text-left font-semibold text-gray-500 uppercase tracking-wider cursor-pointer hover:bg-gray-100"
                    onClick={() => requestSort('concluido_em')}
                  >
                    Concluído em {getSortIcon('concluido_em')}
                  </th>
                  <th className="px-6 py-3 text-left font-semibold text-gray-500 uppercase tracking-wider">
                    Status
                  </th>
                  <th className="px-6 py-3 text-center font-semibold text-gray-500 uppercase tracking-wider">
                    Ações
                  </th>
                </tr>
              </thead>
              <tbody className="divide-y divide-gray-100">
                {concluidasToShow.map((exec) => (
                  <tr key={exec.execucao_id} className="hover:bg-purple-50 transition">
                    <td className="px-6 py-4 font-medium max-w-[250px] truncate">
                      {exec.checklist_modelos?.titulo}
                    </td>
                    <td className="px-6 py-4 text-gray-700">
                      {exec.unidades?.nome}
                    </td>
                    <td className="px-6 py-4 text-gray-700">
                      {new Date(exec.concluido_em).toLocaleString()}
                    </td>
                    <td className="px-6 py-4">
                      <span className="px-2 inline-flex text-xs leading-5 font-semibold rounded-full bg-green-100 text-green-800">
                        Concluído
                      </span>
                    </td>
                    <td className="px-6 py-4 text-center">
                      <div className="flex justify-center gap-2">
                        <button
                          onClick={() => navigate(`/checklist/execucoes/${exec.execucao_id}/detalhes`)}
                          className="flex items-center px-3 py-1.5 rounded-md bg-purple-600 text-white text-xs font-semibold hover:bg-purple-700 transition"
                        >
                          <Eye className="h-4 w-4 mr-1" />
                          Ver
                        </button>
                        <button
                          onClick={() => setDeleteId(exec.execucao_id)}
                          className="flex items-center px-3 py-1.5 rounded-md bg-white text-red-600 border border-red-200 text-xs font-semibold hover:bg-red-50 transition"
                        >
                          <Trash2 className="h-4 w-4 mr-1" />
                          Excluir
                        </button>
                      </div>
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        )}
        <Pagination currentPage={concluidasPage} totalPages={totalConcluidasPages} onPageChange={setConcluidasPage} />
      </div>

      <ConfirmDialog
        open={deleteId !== null}
        title="Confirmar Exclusão"
        message="Tem certeza que deseja excluir esta execução?"
        onConfirm={handleDelete}
        onClose={() => setDeleteId(null)}
      />
    </div>
  );
};

export default ExecucoesListPage;
